/* eslint-disable no-underscore-dangle */
import PagingFeed from '../lib/PagingFeed';

class PagingOsImageFeed extends PagingFeed {
  _getFeed() {
    return this._EntityDef.startOsImageFeed(
      // TODO what is the diff between this and startOsImagesFeed
      this._activeOrgId,
      this._filter,
      this._entityFields,
      this._sort,
      {skip: 0, limit: 100}
    );
  }

  _getDistinctValuesOfField(tenantId, field) {
    return this._EntityDef.startOsImageDistinctValuesFeed(tenantId, field);
  }

  _getFeedIdsForSelection(tenantId, selection) {
    return this._EntityDef.loadOsImageIdsForSelection(tenantId, selection);
  }

  getOsImageEntitiesById(ids) {
    return this.getEntitiesById(ids);
  }

  getOsImageEntitiesNameById(ids) {
    return this.getEntitiesNameById(ids);
  }

  getOsImageEntityById(id) {
    return this.getEntityById(id);
  }
}

export default PagingOsImageFeed;
